/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ApiVersionInformationV1Dto = {
  /**
   * The version of the API
   */
  version: string;
  /**
   * The application environment
   */
  zelosEnvironment: ApiVersionInformationV1Dto.zelosEnvironment;
};
export namespace ApiVersionInformationV1Dto {
  /**
   * The application environment
   */
  export enum zelosEnvironment {
    LOCAL = 'local',
    E2E = 'e2e',
    DEVELOP = 'develop',
    STAGE = 'stage',
    PRELIVE = 'prelive',
    LIVE = 'live',
  }
}
